module.exports = __webpack_public_path__ + "files/de0450cbe1282ccd88f689df3920b83a.png";